import { MB } from '~/shared/const'

export enum AuthMethod {
  phone = 'phone',
  email = 'email',
}

export const METHOD_EXPIRES_IN = 60 * 5

export const CONTACT_REQUEST_MEDIA_ENTITY_TYPE = 'contact_request'

export const CONTACT_REQUEST_MEDIA_BUCKET = 'ms-mail'

export const CONTACT_REQUEST_MAX_FILES = 20

export const CONTACT_REQUEST_MAX_FILE_SIZE_BYTES = 25 * MB

export const PIN_LENGTH = 4

export const PIN_RECOVERY_PROMPT_KEY = 'pin_recovery_prompt'
